import { render, staticRenderFns } from "./NewEdipart.vue?vue&type=template&id=4c83cd1b&scoped=true&"
import script from "./NewEdipart.vue?vue&type=script&lang=js&"
export * from "./NewEdipart.vue?vue&type=script&lang=js&"
import style0 from "./NewEdipart.vue?vue&type=style&index=0&id=4c83cd1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c83cd1b",
  null
  
)

/* custom blocks */
import block0 from "./NewEdipart.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports